import { combineReducers } from 'redux';
import bagQuality from './bag-quality/reducer';
import carbonCalculator from './carbon-calculator/reducer';
import catalog from './catalog/reducer';
import cropMonitoring from './crop-monitoring/reducer';
import fieldTrialNetwork from './field-trial-network/reducer';
import loadingCounter from './loading-counter/reducer';
import maps from './maps/reducer';
import nav from './nav/reducer';
import network from './network/reducer';
import nitrogenRecommendation from './nitrogen-recommendation/reducer';
import notifications from './notifications/reducer';
import publicData from './public-data/reducer';
import recommendations from './recommendations/reducer';
import session from './session/reducer';
import weather from './weather/reducer';
import weedFinder from './weed-finder/reducer';

export default combineReducers({
    nav,
    network,
    session,
    publicData,
    catalog,
    nitrogenRecommendation,
    weedFinder,
    fieldTrialNetwork,
    weather,
    bagQuality,
    carbonCalculator,
    loadingCounter,
    cropMonitoring,
    notifications,
    recommendations,
    maps,
});
